class StoreService {

	constructor(store) {
		const _store = store;
		this.getStore = () => _store;
	}
}

export default new StoreService(null);
